/**
 * 入住信息
 */
import React from 'react';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { OCC_TYPE_MAP } from '@/config/constant';
import { format2FullTimeStr } from '@/utils/date';
import { getOccDuration } from '@/utils';
import { useDetailData } from '@/pages/reservation/reverseRollback/helper';

const Index = () => {
  const { occType, expectedArrivalTime, occDuration, expectedDepartureTime } = useDetailData();

  return (
    <ContentBlock title={intl.get('drawer_reserve_time_block_title')}>
      <FormItem label={intl.get('app_reservation_occ_type')}>{OCC_TYPE_MAP[occType]}</FormItem>
      <br />
      <FormItem label={intl.get('app_reservation_eta_time')}>
        {format2FullTimeStr(expectedArrivalTime)}
      </FormItem>
      <FormItem label={intl.get('app_reservation_occ_duration')}>
        {getOccDuration({
          type: occType,
          duration: occDuration,
          multi: false,
        })}
      </FormItem>
      <FormItem label={intl.get('app_reservation_etd_time')}>
        {format2FullTimeStr(expectedDepartureTime)}
      </FormItem>
    </ContentBlock>
  );
};

export default Index;
